/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_Intro_PreInputs */

const tr_kvkkbasvuru_s2_intro_pre = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri sorumlusu `)
};

const en_kvkkbasvuru_s2_intro_pre = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can submit your applications to the Veri Sorumlusu (data controller) `)
};

const de_kvkkbasvuru_s2_intro_pre = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Anträge an den Veri Sorumlusu (Verantwortlichen) `)
};

const ru_kvkkbasvuru_s2_intro_pre = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свои обращения к Veri Sorumlusu (ответственному за данные) `)
};

/**
* | output |
* | --- |
* | "You can submit your applications to the Veri Sorumlusu (data controller)" |
*
* @param {Kvkkbasvuru_S2_Intro_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_intro_pre = /** @type {((inputs?: Kvkkbasvuru_S2_Intro_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_Intro_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_intro_pre(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_intro_pre(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_intro_pre(inputs)
	return tr_kvkkbasvuru_s2_intro_pre(inputs)
});